import React, { useState } from 'react';
import MainStyles from '../../../styles/MainStyles'
import Text from '../../Text/';
import { checkCPF } from '../../../services/User';
import './index.css'
import i18n from '../../../locales';
import TextError from '../../Text/TextError';
import NumberFormat from 'react-number-format';

const InputCPF = ({labelText, required, setDocument}) => {
	const [isCPFValid, setCPFValid] = useState(null)
	const [isActive, setActive] = useState(null)

	const createPlaceholder = () => {
			return required && !isActive ? labelText + '*' : labelText
	}

  return (
		<div class='form-group form-group-number'>
			<div className='input-number'>
				{ isActive &&
					<Text
						text={createPlaceholder()}
						color={MainStyles.colors.white}
						size={'small'}
						ownClass='label'
					/>
				}
				<NumberFormat
					format="###.###.###-##"
					placeholder={createPlaceholder()}
					mask="_"
					onValueChange={(values) => {
						const {formattedValue, value} = values;
						if(value.length > 0) {
							setActive(true)
						} else {
							setActive(false)
						}
						if(formattedValue.indexOf('_') < 0 && formattedValue.length > 0) {
							setCPFValid(checkCPF(value))
						} else {
							setCPFValid(null)
						}
						if(checkCPF(value)) {
							setDocument(value)
						} else {
							setDocument(null)
						}
				}}/>
			</div>

			{!isCPFValid && isCPFValid !== null &&
				<TextError text={i18n.t('user_form.errors.cpf_invalid')}/>
			}
		</div>
	)
}

export default InputCPF;